import { ThunkType } from "../../../../core/store/reducers";
import { getWeeklyTradingDataExcel } from "../api/getWeeklyTradingDataExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../weeklyTradeDataSlice";
import moment from "moment";

export const downloadWeeklyTradingExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.weeklyTrade;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));

  const weeklyTrading = await dispatch(getWeeklyTradingDataExcel(user, filter));
  if (weeklyTrading) {
    fileDownload(
      new Blob([weeklyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "WeeklyTrading_" + moment().format("YYYYMMDDhhmmss") + ".xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
